// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file user/user_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { PersonalizedUser, User } from './user_model_pb';
import { file_user_user_model } from './user_model_pb';

/**
 * Describes the file user/user_responses.proto.
 */
export const file_user_user_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chl1c2VyL3VzZXJfcmVzcG9uc2VzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJYChJVc2Vyc0J5SWRzUmVzcG9uc2USOgoHc3VjY2VzcxgBIAEoCzInLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVzZXJzQnlJZHNTdWNjZXNzSABCBgoEdHlwZSJKChFVc2Vyc0J5SWRzU3VjY2VzcxI1CgVpdGVtcxgBIAMoCzImLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlBlcnNvbmFsaXplZFVzZXIiYAoWR2V0U2VsZlByb2ZpbGVSZXNwb25zZRI+CgdzdWNjZXNzGAEgASgLMisuY29tLmdlbS5iZmYuY29udHJhY3QuR2V0U2VsZlByb2ZpbGVTdWNjZXNzSABCBgoEdHlwZSJBChVHZXRTZWxmUHJvZmlsZVN1Y2Nlc3MSKAoEdXNlchgBIAEoCzIaLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVzZXIixAQKFVVwZGF0ZVByb2ZpbGVSZXNwb25zZRI9CgdzdWNjZXNzGAEgASgLMiouY29tLmdlbS5iZmYuY29udHJhY3QuVXBkYXRlUHJvZmlsZVN1Y2Nlc3NIABJUChluaWNrbmFtZUFscmVhZHlFeGlzdEVycm9yGAIgASgLMi8uY29tLmdlbS5iZmYuY29udHJhY3QuTmlja25hbWVBbHJlYWR5RXhpc3RFcnJvckgAEloKHHVzZXJuYW1lU3ltYm9sc05vdFZhbGlkRXJyb3IYAyABKAsyMi5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VybmFtZVN5bWJvbHNOb3RWYWxpZEVycm9ySAASTAoVdXNlcm5hbWVUb29TaG9ydEVycm9yGAQgASgLMisuY29tLmdlbS5iZmYuY29udHJhY3QuVXNlcm5hbWVUb29TaG9ydEVycm9ySAASSgoUdXNlcm5hbWVUb29Mb25nRXJyb3IYBSABKAsyKi5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VybmFtZVRvb0xvbmdFcnJvckgAEkwKFW5pY2tuYW1lVG9vU2hvcnRFcnJvchgGIAEoCzIrLmNvbS5nZW0uYmZmLmNvbnRyYWN0Lk5pY2tuYW1lVG9vU2hvcnRFcnJvckgAEkoKFG5pY2tuYW1lVG9vTG9uZ0Vycm9yGAcgASgLMiouY29tLmdlbS5iZmYuY29udHJhY3QuTmlja25hbWVUb29Mb25nRXJyb3JIAEIGCgR0eXBlIkAKFFVwZGF0ZVByb2ZpbGVTdWNjZXNzEigKBHVzZXIYASABKAsyGi5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyImQKGEdldFVzZXJzQnlFbWFpbHNSZXNwb25zZRJACgdzdWNjZXNzGAEgASgLMi0uY29tLmdlbS5iZmYuY29udHJhY3QuR2V0VXNlcnNCeUVtYWlsc1N1Y2Nlc3NIAEIGCgR0eXBlIkMKF0dldFVzZXJzQnlFbWFpbHNTdWNjZXNzEigKBHVzZXIYASADKAsyGi5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyIhsKGU5pY2tuYW1lQWxyZWFkeUV4aXN0RXJyb3IiHgocVXNlcm5hbWVTeW1ib2xzTm90VmFsaWRFcnJvciIXChVVc2VybmFtZVRvb1Nob3J0RXJyb3IiFgoUVXNlcm5hbWVUb29Mb25nRXJyb3IiFwoVTmlja25hbWVUb29TaG9ydEVycm9yIhYKFE5pY2tuYW1lVG9vTG9uZ0Vycm9yQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [file_user_user_model]
  );

/**
 * @generated from message com.gem.bff.contract.UsersByIdsResponse
 */
export type UsersByIdsResponse = Message<'com.gem.bff.contract.UsersByIdsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UsersByIdsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsersByIdsSuccess success = 1;
         */
        value: UsersByIdsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UsersByIdsResponse.
 * Use `create(UsersByIdsResponseSchema)` to create a new message.
 */
export const UsersByIdsResponseSchema: GenMessage<UsersByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 0);

/**
 * @generated from message com.gem.bff.contract.UsersByIdsSuccess
 */
export type UsersByIdsSuccess = Message<'com.gem.bff.contract.UsersByIdsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.PersonalizedUser items = 1;
   */
  items: PersonalizedUser[];
};

/**
 * Describes the message com.gem.bff.contract.UsersByIdsSuccess.
 * Use `create(UsersByIdsSuccessSchema)` to create a new message.
 */
export const UsersByIdsSuccessSchema: GenMessage<UsersByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 1);

/**
 * @generated from message com.gem.bff.contract.GetSelfProfileResponse
 */
export type GetSelfProfileResponse = Message<'com.gem.bff.contract.GetSelfProfileResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetSelfProfileResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetSelfProfileSuccess success = 1;
         */
        value: GetSelfProfileSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetSelfProfileResponse.
 * Use `create(GetSelfProfileResponseSchema)` to create a new message.
 */
export const GetSelfProfileResponseSchema: GenMessage<GetSelfProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 2);

/**
 * @generated from message com.gem.bff.contract.GetSelfProfileSuccess
 */
export type GetSelfProfileSuccess = Message<'com.gem.bff.contract.GetSelfProfileSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message com.gem.bff.contract.GetSelfProfileSuccess.
 * Use `create(GetSelfProfileSuccessSchema)` to create a new message.
 */
export const GetSelfProfileSuccessSchema: GenMessage<GetSelfProfileSuccess> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 3);

/**
 * @generated from message com.gem.bff.contract.UpdateProfileResponse
 */
export type UpdateProfileResponse = Message<'com.gem.bff.contract.UpdateProfileResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UpdateProfileResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateProfileSuccess success = 1;
         */
        value: UpdateProfileSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.NicknameAlreadyExistError nicknameAlreadyExistError = 2;
         */
        value: NicknameAlreadyExistError;
        case: 'nicknameAlreadyExistError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsernameSymbolsNotValidError usernameSymbolsNotValidError = 3;
         */
        value: UsernameSymbolsNotValidError;
        case: 'usernameSymbolsNotValidError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsernameTooShortError usernameTooShortError = 4;
         */
        value: UsernameTooShortError;
        case: 'usernameTooShortError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UsernameTooLongError usernameTooLongError = 5;
         */
        value: UsernameTooLongError;
        case: 'usernameTooLongError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.NicknameTooShortError nicknameTooShortError = 6;
         */
        value: NicknameTooShortError;
        case: 'nicknameTooShortError';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.NicknameTooLongError nicknameTooLongError = 7;
         */
        value: NicknameTooLongError;
        case: 'nicknameTooLongError';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UpdateProfileResponse.
 * Use `create(UpdateProfileResponseSchema)` to create a new message.
 */
export const UpdateProfileResponseSchema: GenMessage<UpdateProfileResponse> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 4);

/**
 * @generated from message com.gem.bff.contract.UpdateProfileSuccess
 */
export type UpdateProfileSuccess = Message<'com.gem.bff.contract.UpdateProfileSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message com.gem.bff.contract.UpdateProfileSuccess.
 * Use `create(UpdateProfileSuccessSchema)` to create a new message.
 */
export const UpdateProfileSuccessSchema: GenMessage<UpdateProfileSuccess> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 5);

/**
 * @generated from message com.gem.bff.contract.GetUsersByEmailsResponse
 */
export type GetUsersByEmailsResponse = Message<'com.gem.bff.contract.GetUsersByEmailsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetUsersByEmailsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUsersByEmailsSuccess success = 1;
         */
        value: GetUsersByEmailsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetUsersByEmailsResponse.
 * Use `create(GetUsersByEmailsResponseSchema)` to create a new message.
 */
export const GetUsersByEmailsResponseSchema: GenMessage<GetUsersByEmailsResponse> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 6);

/**
 * @generated from message com.gem.bff.contract.GetUsersByEmailsSuccess
 */
export type GetUsersByEmailsSuccess = Message<'com.gem.bff.contract.GetUsersByEmailsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.User user = 1;
   */
  user: User[];
};

/**
 * Describes the message com.gem.bff.contract.GetUsersByEmailsSuccess.
 * Use `create(GetUsersByEmailsSuccessSchema)` to create a new message.
 */
export const GetUsersByEmailsSuccessSchema: GenMessage<GetUsersByEmailsSuccess> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 7);

/**
 * @generated from message com.gem.bff.contract.NicknameAlreadyExistError
 */
export type NicknameAlreadyExistError =
  Message<'com.gem.bff.contract.NicknameAlreadyExistError'> & {};

/**
 * Describes the message com.gem.bff.contract.NicknameAlreadyExistError.
 * Use `create(NicknameAlreadyExistErrorSchema)` to create a new message.
 */
export const NicknameAlreadyExistErrorSchema: GenMessage<NicknameAlreadyExistError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 8);

/**
 * @generated from message com.gem.bff.contract.UsernameSymbolsNotValidError
 */
export type UsernameSymbolsNotValidError =
  Message<'com.gem.bff.contract.UsernameSymbolsNotValidError'> & {};

/**
 * Describes the message com.gem.bff.contract.UsernameSymbolsNotValidError.
 * Use `create(UsernameSymbolsNotValidErrorSchema)` to create a new message.
 */
export const UsernameSymbolsNotValidErrorSchema: GenMessage<UsernameSymbolsNotValidError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 9);

/**
 * @generated from message com.gem.bff.contract.UsernameTooShortError
 */
export type UsernameTooShortError = Message<'com.gem.bff.contract.UsernameTooShortError'> & {};

/**
 * Describes the message com.gem.bff.contract.UsernameTooShortError.
 * Use `create(UsernameTooShortErrorSchema)` to create a new message.
 */
export const UsernameTooShortErrorSchema: GenMessage<UsernameTooShortError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 10);

/**
 * @generated from message com.gem.bff.contract.UsernameTooLongError
 */
export type UsernameTooLongError = Message<'com.gem.bff.contract.UsernameTooLongError'> & {};

/**
 * Describes the message com.gem.bff.contract.UsernameTooLongError.
 * Use `create(UsernameTooLongErrorSchema)` to create a new message.
 */
export const UsernameTooLongErrorSchema: GenMessage<UsernameTooLongError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 11);

/**
 * @generated from message com.gem.bff.contract.NicknameTooShortError
 */
export type NicknameTooShortError = Message<'com.gem.bff.contract.NicknameTooShortError'> & {};

/**
 * Describes the message com.gem.bff.contract.NicknameTooShortError.
 * Use `create(NicknameTooShortErrorSchema)` to create a new message.
 */
export const NicknameTooShortErrorSchema: GenMessage<NicknameTooShortError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 12);

/**
 * @generated from message com.gem.bff.contract.NicknameTooLongError
 */
export type NicknameTooLongError = Message<'com.gem.bff.contract.NicknameTooLongError'> & {};

/**
 * Describes the message com.gem.bff.contract.NicknameTooLongError.
 * Use `create(NicknameTooLongErrorSchema)` to create a new message.
 */
export const NicknameTooLongErrorSchema: GenMessage<NicknameTooLongError> =
  /*@__PURE__*/
  messageDesc(file_user_user_responses, 13);
